$(document).ready(function(){

	$('body').on('click', '.switch-tab', function(e) {
		tabSwitch($(this));
	});

	$('body').on('click', '.tab-header', function(e) {
		var tab = $(this).closest($('.tab'));
		if(! $(this).hasClass('tab-review')){
			tabSwitch(tab);
		}
	});


	$(window).on('resize',function(){
		if(window.innerWidth > 767) {
			openFirstTab();
		}
	});
});

function tabSwitch(tab){
	var link = tab.data('link');
	var container = tab.closest('.lening');
	var switchTab = container.find('.switch-tab[data-link="'+link+'"]');
	var allTabs = container.find('.tab, .switch-tab');
	var content = container.find('.switch-tabs-content');
	var linkedContent = content.find('.tab[data-link="'+link+'"]');

	if(! tab.hasClass('active')){
		allTabs.removeClass('active');
		switchTab.addClass('active');
		linkedContent.addClass('active');
	}else{
		switchTab.removeClass('active');
		linkedContent.removeClass('active');
	}
}

function removeActiveTabs() {
	var allActiveTabs = $('.tab.active, .switch-tab.active');
	allActiveTabs.removeClass('active');
}

function openFirstTab() {
	$('.switch-lening-secondary-info').each(function(){
		if($(this).find('.switch-tab.active').length == 0){
			tabSwitch($(this).find('.switch-tab:first-child'));
		}
	});
}